import { IBankTransaction } from '@/services/types/TransactionData';

export const getStatementDetails = (data: IBankTransaction) => {
  return [data.particulars, data.analysis, data.reference].reduce((acc, curr) => {
    if (curr.length) {
      if (acc.length) {
        return `${acc}, ${curr}`;
      }

      return curr;
    }

    return acc;
  }, '');
};
